module.exports = __webpack_public_path__ + "img/r_rendering_icon_01.9bcd199b.png";